import {
  Grid,
  Group,
  Stack,
  Text,
} from '@mantine/core'

import { IconBan } from '@tabler/icons-react'
import moment from 'moment'

import Device from '@data/device/model/device'
import { deviceStateLabel } from '@data/device/model/deviceState'
import { SignalIcon } from '@components/ui/SignalIcon'
import { BattIcon } from '@components/ui/BattIcon'

import {
  getDeviceStatus,
  getPowerStatus,

} from '@common/utils/helperFunctions'
import { ReadOnlyField } from '@components/ui/form/ReadOnlyField'
import { hasPermissions } from '@common/utils/validation/authValidators'
import { TokenPermission } from '@data/rbac/model/rbac'

export interface DeviceStatusTabProps {
  device: Device
  permissions: TokenPermission[]
}

export const DeviceStatusTab = ({ device, permissions }: DeviceStatusTabProps) => {
  const renderDeviceStatus = (
    currentDevice: Device,
  ) => {
    const deviceStatus = getDeviceStatus(
      currentDevice,
      hasPermissions(permissions, [
        'DASHBOARD:STATUS:VIEW',
      ]),
    )

    if (
      deviceStatus === 'Offline' &&
      hasPermissions(permissions, [
        'ACCOUNT:ADMIN:SMARTFLOW',
      ])
    ) {
      return (
        <Group gap='xs'>
          <Text>
            Offline
          </Text>

          <Text size='xs' c='dimmed'>
            (
            last seen:{' '}
            {moment(
              currentDevice.lastOnline,
            ).fromNow()}
            )
          </Text>
        </Group>
      )
    }

    return (
      <Text>
        {deviceStatus}
      </Text>
    )
  }

  return (
    <Stack gap='lg'>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Stack gap={4}>
            <Text fw={600}>
              Battery
            </Text>

            <BattIcon device={device} />
          </Stack>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6 }}>
          {device.batteryStatus ? (
            <ReadOnlyField
              label='Power'
              value={getPowerStatus(device)}
            />

          ) : (
            <Stack gap={4}>
              <Text fw={600}>
                Power
              </Text>

              <IconBan size={18} />
            </Stack>
          )}
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Stack gap={4}>
            <Text fw={600}>
              Signal
            </Text>

            <SignalIcon
              signalLevel={device.signal}
            />
          </Stack>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField
            label='State'
            value={deviceStateLabel(device.deviceSettings.deviceState)}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={12}>
          <Stack gap={4}>
            <Text fw={600}>
              Connection Status
            </Text>

            {device.deviceVendor ===
            'SMARTFLOW' ||
            device.deviceVendor ===
            'METASPHERE' ||
            device.deviceVendor ===
            'PLUM' ? (
              renderDeviceStatus(device)
            ) : (
              <IconBan size={18} />
            )}
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  )
}